// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightMovimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/financeiro-movimento/preflight.
 *
 * `por_tipo` e o que a tela mostra ao lado da tabela: quantas linhas cada
 * lista tem na origem, antes de qualquer carga.
 */
import type { Migration_PreflightMovimentoRow } from './Migration_PreflightMovimentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightMovimentoResponseDados {
registros: Migration_PreflightMovimentoRow[]
por_tipo: Record<string, number>
}

export type Migration_PreflightMovimentoResponse = ApiResponse<Migration_PreflightMovimentoResponseDados>;

registerResponseContract('Migration_PreflightMovimentoResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:    { type: 'string',  required: false },
      tipo:       { type: 'string',  required: false },
      nome:       { type: 'string',  required: false },
      valor:      { type: 'number',  required: false },
      data:       { type: 'string',  required: false },
      ja_migrado: { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
  por_tipo:  { type: 'object',  required: true },
})
